Vue.component('contribution-stacked-chart', {
    props: ['assessment'],
    data() {
        return {
            //
        }
    },
    computed: {
        chartOptions() {
            var series = [];
            var total = 0;
            this.assessment.impact_driver_results.forEach((result, idx, array) => {
                var value = result.contribution;
                total += value;
                if (idx === array.length - 1){
                    // round the last value to make sure we always have a 100 total
                    value -= (total-100)
                }

                series.push({
                    name: result.impact_driver.name,
                    data: [{ value: value, impact: result.total}],
                    type: 'bar',
                    stack: 'total',
                    color: result.impact_driver.map_color_max,
                });
            });

            var chartOptions = {
    tooltip: {
        trigger: 'item',
        axisPointer: {            // Use axis to trigger tooltip
            type: 'shadow'        // 'shadow' as default; can also be 'line' or 'shadow'
        },
        formatter: function (params) {
            return '<strong>'+ params.seriesName + ':</strong> ≈ '+ Vue.filter('result')(params.data.impact) + ' species•yr ('+ Vue.filter('percentage')(params.value) +')';
        }
    },
    grid: {
        left: '0',
        right: '0',
        bottom: '0',
        top: '0',
        containLabel: false
    },
    xAxis: {
        show: false,
        type: 'value'
    },
    yAxis: {
        show: false,
        type: 'category',
        data: ['Impact']
    },
    animation: false,
    series: series,
}

            return chartOptions;
        },
    },
    methods: {
        //
    },
    mounted() {
        //
    }
});